var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookAtivo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#1877F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4758 16.8854L19.8904 14.1553H17.2968V12.3845C17.2968 11.6374 17.6584 10.9087 18.8201 10.9087H20V8.58446C20 8.58446 18.9297 8.39999 17.9068 8.39999C15.7699 8.39999 14.3744 9.70786 14.3744 12.0746V14.1553H12V16.8854H14.3744V23.4856C14.8511 23.5613 15.3388 23.6 15.8356 23.6C16.3324 23.6 16.8201 23.5613 17.2968 23.4856V16.8854H19.4758Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookAtivo);
export default __webpack_public_path__ + "static/media/Facebook-Ativo.66e5c4bc.svg";
export { ForwardRef as ReactComponent };